import React from 'react';
import {Link} from 'react-router-dom';
import {Title, TitleLevel, TitleSize, TitleColor} from 'components/ui/Title';
import ArrowRight from 'components/ui/icon/ArrowRight';
import Container from 'components/layout/Container';

import './Tariffs.scss';

const Tariffs = () => {
  return (
    <section className="tariffs">
      <Container>
        <Title
          extraClassName="tariffs__title"
          level={TitleLevel.H2}
          size={TitleSize.H2}
        >
          Ремонт для любой ситуации
        </Title>

        <ul className="tariffs__subscript">
          <li className="tariffs__subscript-item">
            <p>Цены фиксированные</p>
          </li>
          <li className="tariffs__subscript-item">
            <p>Цена расчитывается за&nbsp;квадратные метры по&nbsp;полу</p>
          </li>
          <li className="tariffs__subscript-item">
            <p>Гарантия 12 месяцев</p>
          </li>
        </ul>

        <div className="tariffs__items">
          <div className="tariffs__item">
            <div className="tariffs__item-heading">
              <Title
                extraClassName="tariffs__item-heading_left"
                level={TitleLevel.H3}
                size={TitleSize.H3}
                color={TitleColor.white}
              >
                Косметический
              </Title>

              <Title
                extraClassName="tariffs__item-heading_right"
                level={TitleLevel.H3}
                size={TitleSize.H3}
                color={TitleColor.white}
              >
                18&nbsp;000&nbsp;₽&nbsp;/ м&sup2;
              </Title>
            </div>

            <p className="tariffs__item-text">
              Если хотите обновить старый ремонт в&nbsp;квартире, без лишних
              действий и&nbsp;затрат. Заменим отделочные покрытия стен, пола
              и&nbsp;потолка. Будет чище и&nbsp;свежее.
            </p>

            <div className="tariffs__item-footer">
              <span className="tariffs__item-footer_left">
                18&nbsp;000&nbsp;₽&nbsp;/ м&sup2;
              </span>

              <Link className="tariffs__button" to={'/tariff/cosmetic'}>
                Список работ
                <ArrowRight color="#70FFFF" />
              </Link>
            </div>
          </div>

          <div className="tariffs__item">
            <div className="tariffs__item-heading">
              <Title
                extraClassName="tariffs__item-heading_left"
                level={TitleLevel.H4}
                size={TitleSize.H3}
                color={TitleColor.white}
              >
                Капитальный
              </Title>

              <Title
                extraClassName="tariffs__item-heading_right"
                level={TitleLevel.H3}
                size={TitleSize.H3}
                color={TitleColor.white}
              >
                33&nbsp;000&nbsp;₽&nbsp;/ м&sup2;
              </Title>
            </div>

            <p className="tariffs__item-text">
              Если хотите основательно переделать ванную комнату. Заменим всё
              старое на&nbsp;всё новое. Чтобы было качественно и&nbsp;красиво
              предварительно подготовим полный пакет проектной
              и&nbsp;строительной документации.
            </p>

            <div className="tariffs__item-footer">
              <span className="tariffs__item-footer_left">
                33&nbsp;000&nbsp;₽&nbsp;/ м&sup2;
              </span>

              <Link className="tariffs__button" to={'/tariff/capital'}>
                Список работ
                <ArrowRight color="#70FFFF" />
              </Link>
            </div>
          </div>

          <div className="tariffs__item">
            <div className="tariffs__item-heading">
              <Title
                extraClassName="tariffs__item-heading_left"
                level={TitleLevel.H4}
                size={TitleSize.H3}
                color={TitleColor.white}
              >
                Дизайнерский
              </Title>

              <Title
                extraClassName="tariffs__item-heading_right"
                level={TitleLevel.H3}
                size={TitleSize.H3}
                color={TitleColor.white}
              >
                56&nbsp;000&nbsp;₽&nbsp;/ м&sup2;
              </Title>
            </div>

            <p className="tariffs__item-text">
              Любые виды демонтажных и&nbsp;отделочных работ, включая
              перепланировку. Сложные архитектурные решения. Работа
              с&nbsp;дорогими материалами.
            </p>

            <div className="tariffs__item-footer">
              <span className="tariffs__item-footer_left">
                56&nbsp;000&nbsp;₽&nbsp;/ м&sup2;
              </span>

              <Link className="tariffs__button" to={'/tariff/design'}>
                Список работ
                <ArrowRight color="#70FFFF" />
              </Link>
            </div>
          </div>

          <div className="tariffs__item tariffs__item_custom">
            <div className="tariffs__item-heading">
              <Title
                extraClassName="tariffs__item-heading_left"
                level={TitleLevel.H4}
                size={TitleSize.H3}
                color={TitleColor.white}
              >
                Индивидуальный
              </Title>
            </div>

            <p className="tariffs__item-text">
              Если вы&nbsp;точно знаете, какие работы вым нужны
              и&nbsp;не&nbsp;хотите переплачивать за&nbsp;лишние услуги. Часто
              подходит тем, кто делает ремонт самостоятельно, но&nbsp;нуждается
              в&nbsp;помощи профессиналов.
            </p>

            <div className="tariffs__item-footer">
              <Link className="tariffs__button" to={'/tariff/custom'}>
                Выбрать работы
                <ArrowRight color="#70FFFF" />
              </Link>
            </div>
          </div>
        </div>

        <ul className="tariffs__caption">
          <li className="tariffs__caption-item">
            <p>Цены фиксированные</p>
          </li>
          <li className="tariffs__caption-item">
            <p>Цена расчитывается за&nbsp;квадратные метры по&nbsp;полу</p>
          </li>
          <li className="tariffs__caption-item">
            <p>Гарантия 12 месяцев</p>
          </li>
          <li className="tariffs__caption-item">
            <p>Материалы не&nbsp;входят в&nbsp;стоимость ремонта</p>
          </li>
        </ul>

        <p className="tariffs__caption_desktop">
          ⓘ Материалы не&nbsp;входят в&nbsp;стоимость ремонта
        </p>
      </Container>
    </section>
  );
};

export default Tariffs;
